import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BeUsuario } from '@app/models/BeUsuario';

export interface DialogSelectUsuarioData {
  title: string;
  message: string;
  usuarios: BeUsuario[];
}

@Component({
  selector: 'app-dialog-select-usuario',
  templateUrl: './dialog-select-usuario.component.html',
  styleUrls: ['./dialog-select-usuario.component.css']
})
export class DialogSelectUsuarioComponent {
  public usuarioSelecionado?: number;

  public constructor(
    public dialogRef: MatDialogRef<DialogSelectUsuarioComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogSelectUsuarioData
  ) {}

  public onConfirmar(): void {
    if (this.usuarioSelecionado) {
      this.dialogRef.close(this.usuarioSelecionado);
    }
  }

  public onCancelar(): void {
    this.dialogRef.close();
  }
}
